import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Divide = createReactComponent("Divide", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "6",
  r: "1",
  key: "g09ld9"
}], ["line", {
  x1: "5",
  y1: "12",
  x2: "19",
  y2: "12",
  key: "iqslzh"
}], ["circle", {
  cx: "12",
  cy: "18",
  r: "1",
  key: "1r2cf2"
}]]]);
export default Divide;